<template>
    <component
        :is="display"
        :resources="resources"
        :pins="pins"
        :icons="icons"
        :getIcon="getIcon"
    />
</template>

<script setup>
import { computed } from "vue";
import { useUser } from "@/Composables";
import MarketingContent from "@/Themes/Marketing/Components/Modules/Resources/ResourceList.vue";
import SourcingContent from "@/Themes/Sourcing/Components/Modules/Resources/ResourceList.vue";
import config from "@/config";

const props = defineProps({
    resources: {
        type: Array,
        required: false,
    },
    pins: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode ? SourcingContent : MarketingContent
);

function getIcon(type) {
    return config.resources.icons[type] ?? 'icon-draft-paper';
}
</script>
